import React, { useState, useEffect } from "react";
import { ScrollView, KeyboardAvoidingView, View } from "react-native";

import { find } from "lodash";

import Utils, {
  hasItems,
  escapeRegexp,
  getElementModel,
  getStorageItem,
  getStorageKey,
  navigate,
  setStorageItem,
} from "../../../../helpers/utils";

import Search from "../../common/search-bar/Search";
import LoadingIndicator from "../../common/LoadingIndicator";
import appStyles from "../../../appStyles";
import ElementsFabButton from "./ElementsFabButton";
import ElementsList from "../../elements/list/ElementsList";
import TutorialsHelper from "../../tutorials/TutorialsHelper";

import TUTORIALS_DATA from "../../tutorials/data";
import Header from "../../common/header/index";
import { element } from "prop-types";

export default function EditRoutineElements({
  controller,
  currentElements,
  goBack,
  showAll = false,
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [allElements, setAllElements] = useState([]);
  const [elements, setElements] = useState([]);
  const [selectedElements, setSelectedElements] = useState(new Set());
  const [mariMessage, setMariMessage] = useState("");
  const [showTutorials, setShowTutorials] = useState(false);

  useEffect(() => {
    let elementsList = controller.state.elements.filter(
      (el) => el.is_active == 1,
    );

    const storageKey = getStorageKey(controller, "routine_element");

    getStorageItem(storageKey).then((newElementId) => {
      let allSelected = hasItems(currentElements) ? currentElements : [];

      // Newly created element
      if (newElementId) {
        setStorageItem(storageKey, null);
        allSelected.push({ id_activity: newElementId });
      }

      if (hasItems(allSelected)) {
        elementsList = initElements(elementsList, allSelected);
      }

      setAllElements(elementsList);
      setElements(elementsList);
      setIsLoading(false);

      // Tutorials
      initTutorials();
    });
  }, [controller.state.elements]);

  const initElements = (elementsList, allSelected = []) => {
    let selectedList = new Set();

    elementsList.forEach((a) => {
      a.is_selected = false;
      const found = find(
        allSelected,
        (ca) => a.id == ca.id_activity.replace("_misc", ""),
      );

      if (found) {
        a.is_selected = true;
        a.hours = found.hours;
        a.total_hours = found.total_hours;
        a.is_modified = found.is_modified;
        a.dayIndex = found.dayIndex;
        a.is_uncategorized = found.is_uncategorized;
        selectedList.add(a.id);
      }
    });

    setSelectedElements(selectedList);

    elementsList.sort((a, b) => {
      if (a.is_selected == b.is_selected) {
        if (a.is_favorite == b.is_favorite) {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
        }
        return a.is_favorite < b.is_favorite ? 1 : -1;
      }

      return a.is_selected > b.is_selected ? -1 : 1;
    });

    return elementsList;
  };

  // ------------------------------------- FILTER -------------------------------------
  const filterResults = (filters) => {
    const { term = null } = filters != null ? filters : {};
    let filtered = allElements;

    // Multi terms search
    if (term) {
      const pattern = Utils.getSearchPattern(term);

      filtered = filtered.filter((a) => {
        return a.name && a.name.match(pattern);
      });
    }

    setIsLoading(false);
    setElements(filtered);
  };

  // ------------------------------------- ELEMENTS -------------------------------------
  const updateselectedElements = (element, is_selected) => {
    if (is_selected) {
      selectedElements.add(element.id);
    } else {
      selectedElements.delete(element.id);
    }

    setSelectedElements(selectedElements);
  };

  const addElement = () => {
    navigate(controller, "rn:edit_element", "changepage", {
      element: getElementModel(),
      returnUrl: "routines",
    });
  };

  // ------------------------------------- UPDATE -------------------------------------
  const confirmElements = () => {
    const confirmed = allElements
      .filter((elem) => selectedElements.has(elem.id))
      .map((a) => {
        return {
          ...a,
          hours: a.hours || 0,
          total_hours: a.total_hours || 0,
          id_activity: a.id,
        };
      });

    goBack({ elements: confirmed });
  };

  // ------------------------------------- TUTORIALS -------------------------------------
  const initTutorials = () => {
    const isTutorialMode = (controller?.state?.showTutorials || {})[
      TutorialsHelper.STORAGE_KEYS.reflection
    ];

    setShowTutorials(isTutorialMode);

    if (isTutorialMode) {
      const tutorial = TUTORIALS_DATA["average_week"][6];
      setMariMessage(tutorial.message);
    } else {
      setMariMessage("");
    }
  };

  return (
    <View style={appStyles.container}>
      <KeyboardAvoidingView style={appStyles.kbViewNoFooter} behavior="height">
        <Header
          title="Edit Elements"
          subTitle="Choose elements that are relevant to you."
          isLoading={isLoading}
          goBack={confirmElements}
          highlightBack={showTutorials}
        />

        <LoadingIndicator isLoading={isLoading} />

        <ScrollView
          style={appStyles.scrollView}
          contentContainerStyle={appStyles.scrollViewContent}
        >
          {hasItems(elements) ? (
            <ElementsList
              elements={elements}
              initialNumToRender={showAll ? elements.length : 10}
              controller={controller}
              onElementSelected={(item, isSelected) =>
                updateselectedElements(item, isSelected)
              }
              showSelector
            />
          ) : null}
        </ScrollView>

        <ElementsFabButton
          addElement={addElement}
          mariOptions={{ mariMessage: mariMessage, showTutorials }}
        />

        <Search
          showIcon={false}
          filterResults={filterResults}
          placeholder="Search Elements"
          inputStyle={{ backgroundColor: "#FFF" }}
          controller={controller}
        />
      </KeyboardAvoidingView>
    </View>
  );
}
